import { render, staticRenderFns } from "./comissoes.vue?vue&type=template&id=5a31229e"
import script from "./comissoes.vue?vue&type=script&lang=js"
export * from "./comissoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports